<template>
  <div class="appbackground d-flex" style="flex-direction: column; align-items: center;">
    <div style="margin-top: 12px;">
      <img src="../../assets/service-me-logo.png" style="width: 150px;">
    </div>
    <div
      style="display: flex; flex-direction: column; height: 100%; align-items: center; min-width: 270px; max-width: 500px; margin: 10% 0 0 0; width: 100%;">
      <div v-if="this.logoImage != null && this.logoImage != 'default-logo'"
        style="display:flex;justify-content:center; align-items: center;height: 70px; width: 270px; margin-bottom: 12px">
        <img :src="`${this.logoImage}`" style="max-height: 70px; max-width: 270px;"
          height="auto">
      </div>
      <div v-if="this.logoImage == 'default-logo'"
        style="display:flex;justify-content:center; align-items: end; height: 70px; width: 270px; margin-bottom: 12px">
        <img src="../../assets/service-me-logo.png" style="max-height: 70px; max-width: 270px;" height="auto">
      </div>
      <div class="w-100" style="position: relative;">
        <v-progress-linear v-if="loading" absolute indeterminate color="#572F7B"></v-progress-linear>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>

import { HTTP } from '@/plugins/backendAPI'
import { mapGetters } from 'vuex';

export default {
  props: ['qrstring', 'workspaceid', 'qrworkspaceid'],

  data() {
    return {
      contactRequest: 'Contact request',
      feedback: 'Feedback',
      inventorytypes: [],
      isFormsActive: {},
      location: null,
      organization: null,
      logoImage: null,
      // eslint-disable-next-line no-undef
      backendurl: process.env.VUE_APP_APIURL,
      qrName: null,
      workspaceId: null,
      qrWorkspaceId: null,
    }
  },

  computed: {
    ...mapGetters([
      "ismobileauthorized",
      "loading"
    ])
  },

  async created() {
    this.$store.dispatch('saveLegacyMobileParams', this.qrstring)
    this.$store.dispatch('saveMobileParams', [this.workspaceid, this.qrworkspaceid])

    this.$store.dispatch('setLoading', true)

    try {
      const qrRequest = HTTP.get(`/mobil/checkifqrexists/${this.qrstring}/${this.workspaceid}/${this.qrworkspaceid}`)
      let logoRequest = null

      if (this.qrstring) {
        logoRequest = HTTP.get(`/mobil/get/logo/legacy/${this.qrstring}`)
      } else if (this.workspaceid && this.qrworkspaceid) {
        logoRequest = HTTP.get(`/mobil/get/logo/${this.workspaceid}`)
      }

      const [qrResponse, logoResponse] = await Promise.all([
        qrRequest,
        logoRequest
      ])

      this.$store.dispatch("saveQrCodeStatus", qrResponse.data.isFound)
      this.$store.dispatch("setLanguageOption", qrResponse.data.languageOption)
      this.$store.dispatch("doesOrganizationUseForms", qrResponse.data.useForms)

      if (qrResponse.data.isUsePinCode) {
        this.$store.dispatch("usePinCodeForMobileAuth")
      } else {
        this.$store.dispatch("dontUsePinCodeForMobileAuth")
      }

      this.logoImage = logoResponse?.data?.imageUrl || "default-logo"

    } catch (err) {
      console.error(err)

      this.logoImage = "default-logo"

      if (err?.response?.data) {
        this.$store.dispatch("showError", err.response.data)
      }
    } finally {
      this.$store.dispatch('setLoading', false)
    }
  },
}
</script>

<style>
.edit-qr {
  display: inline-block;
  font-size: 18px;
  text-decoration: underline;
  margin-top: 120px;
  cursor: pointer;
  color: lightgray;
}

.edit-qr:hover {
  color: lightskyblue;
}

.btn-report-container {
  position: relative;
}

.btn-wrap-txt {
  white-space: normal;
  word-wrap: break-word;
  overflow: hidden;
  width: 180px;
  max-height: 60px;
  margin: 0;
}

.active-report-icon {
  position: absolute;
  z-index: 50;
  right: -8px;
  top: -5px;
  height: 35px;
}
</style>
